<template>
  <el-row style="margin: 0 0 20px 0">
    <el-col :span="24">
      <slot></slot>
    </el-col>
  </el-row>
</template>
<script setup>
defineOptions({
  name: "QueryForm",
});
</script>
<style lang="scss" scoped></style>
